import React, { useEffect, useState } from 'react'
//@ts-ignore
import s from './RadioSwitcher.module.scss'
import { SwitchStandardBase } from '../../BaseComponent/SwitchStandardBase/SwitchStandardBase'
import { setValueMultipleOptions, setValueOptions } from '../../../store/actions/setting'
import { getValueMultipleOption, getValueOption, valueMultipleOption, valueOption } from '../../../store/selectors/selectors'
import { useDispatch, useSelector } from 'react-redux';
//@ts-ignore
import { getUrlImg } from '../../../utils/utilsFunctions'

type value = {
    id: string,
    img: string,
    name: string,
}
type RadioSwitcherT = {
    id: string,
    parentKeySection?: any
    values: value[]
}
export const RadioSwitcher = ({ ...props }: RadioSwitcherT) => {
    const [state, setValue]: any = useState()
    let { id, parentKeySection, values } = props

    const dispatch = useDispatch();

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));
    const onChange = (value: value) => {
        setValue(value['id'])
        dispatch(setValueOptions({ idParams: id, valueParam: value['id'] }))
    }

    useEffect(() => {
        setValue(selectValue)
    }, [])

    let checked: boolean = false;

    return (
        <div className={s.wrapSwitcher}>
            {values.map((value: value) => {


                checked = value['id'] === state



                return (<div className={s.item} key={value['id']}>
                    <img src={getUrlImg(value['img'])} alt={value['name']} />
                    <SwitchStandardBase checked={checked} label={value['name']} onChange={() => onChange(value)} />

                </div>)
            })}

        </div>
    )
}
